<template>
  <v-layout column wrap>
    <v-text-field v-model="value" :label="prop.text" :readonly="readonly" :id="prop.value" :name="prop.text"
      :error-messages="error">
      <template #append>
        <v-fade-transition leave-absolute>
          <v-img :src="source" :width="32" :height="32"></v-img>
        </v-fade-transition>
      </template>
    </v-text-field>
    <v-img :src="source" :width="300" v-show="source"></v-img>
  </v-layout>

</template>

<style scoped>

</style>

<script>
  import ImageInput from "./imageInput.ts";
  export default ImageInput;
</script>